import { render } from "./DataUsageWarning.vue?vue&type=template&id=9af81b76&scoped=true"
import script from "./DataUsageWarning.vue?vue&type=script&lang=js"
export * from "./DataUsageWarning.vue?vue&type=script&lang=js"

import "./DataUsageWarning.vue?vue&type=style&index=0&id=9af81b76&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af81b76"]])

export default __exports__